import { VueRecaptcha } from 'vue-recaptcha';

import UiIcon from '@/components/UIElements/UiIcon.vue';
import UiButton from '@/components/UIElements/UiButton.vue';
import UiInput from '@/components/UIElements/UiInput.vue';
import UiLabel from '@/components/UIElements/UiLabel.vue';
import UiTable from '@/components/UIElements/UiTable.vue';
import UiTableNew from '@/components/UIElements/UiTableNew.vue';
import UiPagination from '@/components/UIElements/UiPagination.vue';
import UiPopupCol from '@/components/UIElements/UiPopupCol.vue';
import UiConfirm from '@/components/UIElements/UiConfirm.vue';
import Popup from '@/components/Popup.vue';
import UiHelp from '@/components/UIElements/UiHelp.vue';
import ActionIcon from '@/components/ActionIcon.vue';
import UiCurrencyPicker from '@/components/UIElements/UiCurrencyPicker.vue';
import UiSelectTags from '@/components/UIElements/UiSelectTags.vue';
import UiTabs from '@/components/UIElements/UiTabs.vue';
import UiTitle from '@/components/UIElements/UiTitle.vue';
import UiToolbar from '@/components/UIElements/UiToolbar.vue';
import UiMessenger from '@/components/UIElements/UiMessenger.vue';
import UiDatePicker from '@/components/UIElements/UiDatePicker.vue';
import CardBlock from '@/components/CardComponents/CardBlock.vue';
import CardTitle from '@/components/CardComponents/CardTitle.vue';
import CardItem from '@/components/CardComponents/CardItem.vue';
import UiAction from '@/components/UIElements/UiAction.vue';
import UiSeparator from '@/components/UIElements/UiSeparator.vue';
import UiSelectElement from '@/components/UIElements/UiSelectElement.vue';
import UiScrollbar from '@/components/UIElements/UiScrollbar.vue';
import UiStatusText from '@/components/UIElements/UiStatus/UiStatusText.vue';
import UiStatusBlock from '@/components/UIElements/UiStatus/UiStatusBlock.vue';
import UiTooltip from '@/components/UIElements/UiTooltip.vue';
import UiSwitch from '@/components/UIElements/UiSwitch.vue';
import UiDropdown from '@/components/UIElements/UiDropdown.vue';
import UiRadioGroup from '@/components/UIElements/UiRadio/UiRadioGroup.vue';
import UiRadioButton from '@/components/UIElements/UiRadio/UiRadioButton.vue';
import UiCheckboxGroup from '@/components/UIElements/UiCheckbox/UiCheckboxGroup.vue';
import UiCheckbox from '@/components/UIElements/UiCheckbox/UiCheckbox.vue';
import UiTextarea from '@/components/UIElements/UiTextarea.vue';
import UiRangeInput from '@/components/UIElements/UiRangeInput.vue';
import FormRow from '@/components/FormRow.vue';
import BrandsList from '@/components/BrandsList.vue';
import UiDetailsTree from '@/components/UIElements/UiDetailsTree.vue';
import ExportData from '@/components/ExportData.vue';
import UiFilterElement from '@/components/UIElements/UiFilter/UiFilterElement.vue';
import UiFilterItem from '@/components/UIElements/UiFilter/UiFilterItem.vue';

import DefaultFilter from '@/components/DefaultFilter.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import Flag from '@/components/Flag.vue';
import Panel from '@/components/Panel.vue';
import FilesList from '@/components/FilesList.vue';
import CardNavigation from '@/components/CardNavigation.vue';



export default (Vue) => {
  Vue.component('UiPagination', UiPagination);
  Vue.component('UiIcon', UiIcon);
  Vue.component('UiButton', UiButton);
  Vue.component('UiInput', UiInput);
  Vue.component('UiLabel', UiLabel);
  Vue.component('UiTable', UiTable);
  Vue.component('UiTableNew', UiTableNew);
  Vue.component('UiPopupCol', UiPopupCol);
  Vue.component('UiConfirm', UiConfirm);
  Vue.component('Popup', Popup);
  Vue.component('ActionIcon', ActionIcon);
  Vue.component('UiHelp', UiHelp);
  Vue.component('UiCurrencyPicker', UiCurrencyPicker);
  Vue.component('UiDatePicker', UiDatePicker);
  Vue.component('CardBlock', CardBlock);
  Vue.component('CardTitle', CardTitle);
  Vue.component('CardItem', CardItem);
  Vue.component('UiAction', UiAction);
  Vue.component('UiSeparator', UiSeparator);
  Vue.component('UiSelectElement', UiSelectElement);
  Vue.component('UiScrollbar', UiScrollbar);
  Vue.component('UiSelectTags', UiSelectTags);
  Vue.component('UiTabs', UiTabs);
  Vue.component('UiTitle', UiTitle);
  Vue.component('UiToolbar', UiToolbar);
  Vue.component('UiMessenger', UiMessenger);
  Vue.component('UiStatusText', UiStatusText);
  Vue.component('UiStatusBlock', UiStatusBlock);
  Vue.component('FormRow', FormRow);
  Vue.component('UiTooltip', UiTooltip);
  Vue.component('UiSwitch', UiSwitch);
  Vue.component('UiDropdown', UiDropdown);
  Vue.component('UiRadioGroup', UiRadioGroup);
  Vue.component('UiRadioButton', UiRadioButton);
  Vue.component('UiCheckboxGroup', UiCheckboxGroup);
  Vue.component('UiCheckbox', UiCheckbox);
  Vue.component('UiTextarea', UiTextarea);
  Vue.component('UiRangeInput', UiRangeInput);
  Vue.component('BrandsList', BrandsList);
  Vue.component('ExportData', ExportData);
  Vue.component('VueRecaptcha', VueRecaptcha);
  Vue.component('UiDetailsTree', UiDetailsTree);
  Vue.component('UiFilterElement', UiFilterElement);
  Vue.component('UiFilterItem', UiFilterItem);
  Vue.component('DefaultFilter', DefaultFilter);
  Vue.component('Breadcrumbs', Breadcrumbs);
  Vue.component('Flag', Flag);
  Vue.component('Panel', Panel);
  Vue.component('FilesList', FilesList);
  Vue.component('CardNavigation', CardNavigation);
};
